<template>
    <div>
        <div class="form-group select">
            <label :for="themeFieldName" class="control-label">Theme</label>
            <select
                class="form-control"
                :id="themeFieldName"
                @change="themeInput"
                :name="themeFieldName"
                :value="theme"
            >
                <option
                    :value="tenantConfigurationThemeOption"
                    v-for="tenantConfigurationThemeOption in tenantConfigurationThemeOptions"
                    v-text="tenantConfigurationThemeOption"
                ></option>
            </select>
        </div>
        <div class="form-group select" v-if="theme === tenantConfigurationThemes.ARTIFICIAL_REASON">
            <label :for="styleSheetFieldName" class="control-label">Stylesheet</label>
            <select
                class="form-control"
                :id="styleSheetFieldName"
                @change="styleSheetInput"
                :name="styleSheetFieldName"
                required
                :value="styleSheet"
            >
                <option
                    disabled
                    :selected="!styleSheet && !initialStyleSheet"
                    value
                >
                    -- Select a style sheet --
                </option>
                <option
                    :value="artificialReasonStyleSheet"
                    v-for="artificialReasonStyleSheet in artificialReasonStyleSheets"
                    v-text="artificialReasonStyleSheet"
                ></option>
            </select>
        </div>
    </div>
</template>

<script>
import TenantConfigurationThemes from './consts/themes';

export default {
    name: 'ThemeSelect',

    props: {
        styleSheet: {
            default: '',
            required: false,
            type: String,
        },
        styleSheetFieldName: {
            default: 'tenant_configuration[style_sheet]',
            required: false,
            type: String,
        },
        theme: {
            required: true,
            type: String,
        },
        themeFieldName: {
            default: 'tenant_configuration[theme]',
            required: false,
            type: String,
        },
    },

    data() {
        return {
            artificialReasonStyleSheets: [
                'style-aqua',
                'style-blue',
                'style-blue2',
                'style-blue3',
                'style-blue4',
                'style-blue5',
                'style-fuchsia',
                'style-gray',
                'style-green',
                'style-green2',
                'style-green3',
                'style-green4',
                'style-green5',
                'style-orange',
                'style-orange2',
                'style-orange3',
                'style-pink',
                'style-red',
                'style-red2',
                'style-red3',
                'style-violet',
                'style-violet2',
                'style-violet3',
                'style-yellow',
                'style-yellow2',
            ],
            //<INITIAL-STYLESHEET>
            //This is used, so that if the initial Theme value was AR, and therefore there was a stylesheet set, if the
            //User changes the theme from AR, and then BACK to AR, that stylesheet gets auto-set when they change back
            //</>INITIAL-STYLESHEET>
            initialStyleSheet: '',
            tenantConfigurationThemes: TenantConfigurationThemes,
            tenantConfigurationThemeOptions: Object.values(TenantConfigurationThemes),
        }
    },

    watch: {
        theme(newVal, oldVal) {
            if (newVal === TenantConfigurationThemes.ARTIFICIAL_REASON) {
                this.$emit('stylesheetinput', this.initialStyleSheet);
                return;
            }

            if (oldVal === TenantConfigurationThemes.ARTIFICIAL_REASON) {
                this.$emit('stylesheetinput', '');
            }
        },
    },

    created() {
        Object.assign(this, {initialStyleSheet: this.styleSheet});
    },

    methods: {
        styleSheetInput(e) {
            this.$emit('stylesheetinput', e.target.value);
        },
        themeInput(e) {
            this.$emit('themeinput', e.target.value);
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/TenantConfigurations/ThemeSelect.vue